/**
 * Identity header for the inventory detail view — the canonical `DetailHeader`:
 * breadcrumb trail, an optional muted reference prefix (service_tag / ref), the
 * item name, the status pill as meta, and optional right-aligned actions.
 * Split out of `inventory-detail-view.tsx` to keep that file focused on the tabs.
 */
import type { ReactNode } from 'react';
import type { Item } from '@/api/capacities';
import { DetailHeader } from '@/components/detail-header';
import { itemStatusCell } from './items-status';

export interface InventoryDetailHeaderProps {
  backTo: string;
  backLabel: string;
  reference?: string;
  item: Item;
  /** Right-aligned header actions (e.g. Delete button). */
  actions?: ReactNode;
}

/** Breadcrumb + name (with muted reference prefix) + status pill + optional actions. */
export function InventoryDetailHeader({
  backTo,
  backLabel,
  reference,
  item,
  actions,
}: InventoryDetailHeaderProps) {
  return (
    <DetailHeader
      parent={[
        { label: 'Capacities & Resources', to: '/capacities' },
        { label: backLabel, to: backTo },
      ]}
      current={item.name || reference}
      idPrefix={reference}
      title={item.name}
      meta={itemStatusCell(item.status)}
      actions={actions}
    />
  );
}
